export default __webpack_public_path__ + "static/tube-mobile@2x-41c21799a29cea462baad977b6cf364f.webp";